import { SignIn } from '@clerk/react'
import { getActivePod } from '@/lib/pod'

/**
 * The staff surface's sign-in screen, shared by every staff page so the words
 * and the invite-only notice cannot drift between them. `returnTo` is where
 * Clerk sends the person after signing in — the page they were trying to open.
 */
export default function StaffSignIn({ returnTo }: { returnTo: string }) {
  const pod = getActivePod()
  return (
    <main className="flex min-h-[100svh] items-center justify-center bg-surface-base px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <h1 className="font-display text-xl font-semibold tracking-tight">{pod.brandName}</h1>
          <p className="mt-1 text-sm text-text-muted">
            {pod.productName} {pod.roleLabel} — please sign in.
          </p>
        </div>
        <div className="flex justify-center">
          <SignIn forceRedirectUrl={returnTo} />
        </div>
        <p className="mt-6 text-center text-xs text-text-muted">
          Access is by invitation from the office only.
        </p>
      </div>
    </main>
  )
}
